// extracted by mini-css-extract-plugin
export default {"wrapper":"arrow-link-module--wrapper--539c4","arrow":"arrow-link-module--arrow--5c4d5"};